import request from '@/utils/request'

export function loginByUsername(username, password) {
  const data = {
    username,
    password,
  }
  return request({
    url: '/api/v1/jkPublic/login',
    method: 'post',
    data
  })
}
export function logout() {
  return request({
    url: 'api/v1/jk/logout',
    method: 'post'
  })
}

export function getUserInfo(data) {
  return request({
    url: '/api/v1/jk/userInfo',
    method: 'post',
    data
  })
}

export function getSmsAppList(data) {
  return request({
    url: '/api/v1/jk/getSmsAppList',
    method: 'post',
    data
  })
}
